
export default function TrustIndicators() {
  const stats = [
    { number: '500+', label: 'Companies Served', icon: 'ri-building-line' },
    { number: '10,000+', label: 'Successful Placements', icon: 'ri-user-star-line' },
    { number: '95%', label: 'Success Rate', icon: 'ri-trophy-line' },
    { number: '20+', label: 'Industries Covered', icon: 'ri-global-line' }
  ];

  return (
    <section className="bg-gray-50 py-16 border-y border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center relative"
            >
              <div className="flex justify-center mb-3">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full">
                  <i className={`${stat.icon} text-2xl text-teal-600`}></i>
                </div>
              </div>
              <div className="text-4xl lg:text-5xl font-bold text-gray-900 mb-2">
                {stat.number}
              </div>
              <div className="text-sm lg:text-base text-gray-600 font-medium">
                {stat.label}
              </div>
              {index < stats.length - 1 && (
                <div className="hidden lg:block absolute right-0 top-1/2 transform -translate-y-1/2 w-px h-16 bg-gray-300"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
